module.exports = __webpack_public_path__ + "media/images/flags/32/Senegal-c31c8bcf4efb7ae652203dc476aa7ee5.png";